import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import TablePagination from "@material-ui/core/TablePagination"

const AdminPagination = props => {
    const { rows, pagination } = props
    const { t } = useTranslation()
    const location = useLocation()
    const history = useHistory()

    function handleChangePage(_, newPage) {
        const query = queryString.parse(location.search)
        updateQuery({ ...query, currPage: newPage === 0 ? null : newPage + 1 })
    }

    function handleChangeRowsPerPage(event) {
        const query = queryString.parse(location.search)
        updateQuery({ ...query, perPage: event.target.value })
    }

    function updateQuery(newQuery) {
        const newQueryString = queryString.stringify(newQuery, { skipNull: true })
        window.scrollTo({ top: 0, behavior: "smooth" })
        history.push({ pathname: location.pathname, search: newQueryString })
    }

    const { total, perPage, currPage } = pagination
    const page = currPage - 1 // zero based
    if (page > total / perPage - 1 && rows.length === 0) return null

    return (
        <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
            count={total}
            rowsPerPage={perPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("view.admin.paginationLabel")}
        />
    )
}

export default AdminPagination
